import { apiClient } from "@/lib/api";
import type { Changed } from "@/components/table/changedColumns";

// Transport → Ontbrekende CMR's (docs/scantafel.md §13): the consignments WLX unloaded whose signed CMR is not in yet.

export const MISSING_CMR_STATES = ["missing", "recent", "no_return"] as const;
export type MissingCmrState = (typeof MISSING_CMR_STATES)[number];

/** How far back the list looks, in days, as the API takes it. */
export const PERIOD_DAYS = [14, 30, 60, 90] as const;
export type PeriodDays = (typeof PERIOD_DAYS)[number];
export const DEFAULT_PERIOD_DAYS: PeriodDays = 60;

export interface MissingCmr extends Changed {
  /** The consignment. */
  id: string;
  number: string;
  reference: string | null;
  order: { id: string; number: string; customer: string; customerId: string; /** Factuurreferentie. */ reference: string | null };
  loading: { day: string; locationName: string; city: string; reference: string | null } | null;
  unloading: { day: string; locationName: string; city: string; reference: string | null; stopStatus: string };
  /** Whole days since the unloading day. */
  days: number;
  trip: { id: string; tripNumber: string; status: string } | null;
  vehicle: { code: string; licensePlate: string | null } | null;
  driver: { code: string; name: string } | null;
  charter: string | null;
  noCmrReturn: boolean;
}

export interface MissingCmrList {
  items: MissingCmr[];
  counts: Record<MissingCmrState, number>;
  /** Of the missing ones: unloaded more than overdueDays ago, and unloaded by a charter. */
  overdue: number;
  byCharter: number;
  graceDays: number;
  overdueDays: number;
}

export const missingCmrKeys = {
  all: ["missing-cmrs"] as const,
  list: (state: MissingCmrState, days: PeriodDays) => ["missing-cmrs", state, days] as const,
};

export function listMissingCmrs(state: MissingCmrState, days: PeriodDays): Promise<MissingCmrList> {
  return apiClient.get<MissingCmrList>(`/api/v1/missing-cmrs?state=${state}&days=${days}`);
}
